function initOwlCarousels() {
  $(".owl-carousel").each(function () {
    var $carousel = $(this);

    // Prevent re-initializing already active carousels
    if ($carousel.hasClass('owl-loaded')) return;

    $carousel.owlCarousel({
      items: 1,
      loop: false,
      margin: 10,
      autoplay: false,
      dots: false,
    });

    $carousel.on('changed.owl.carousel', function (event) {
      var currentIndex = event.item.index;
      var $items = $(event.target).find(".owl-item");

      for (let i = currentIndex; i <= currentIndex + 2; i++) {
        var $img = $items.eq(i).find("img.lazy-image");
        if ($img.length && !$img.attr("src")) {
          $img.attr("src", $img.data("src"));
        }
      }
    });
  });
}

$(document).ready(function () {
  initOwlCarousels();
});

// function reinitOwlCarousels() {
//   initOwlCarousels();
// }



// grid layout switch functionlity starts

const default_layout_btn = document.getElementById("default-layout-btn");
const custom_layout_btn = document.getElementById("custom-layout-btn");
const wrapper = document.querySelector(".collection_wrapper");
let loadingState;
function setDefaultLayout() {
  const elements = document.querySelectorAll(".collection-slide-wrapper");
  localStorage.setItem("layout", "");
  wrapper && wrapper.classList.remove("custom_layout");
  $(".owl-carousel").trigger("refresh.owl.carousel");

  elements.forEach((element) => {
    element.style.gridColumn = "span 1";
    element.style.gridRow = "span 1";
    element.querySelector(".product-card").style.height = "auto";
  });

  setTimeout(() => {
    $(".owl-carousel").trigger("refresh.owl.carousel");
  }, 100);
}

function setCustomLayout() {
  localStorage.setItem("layout", "custom_layout");
  loadingState = localStorage.getItem("layout");
  wrapper.classList.add("custom_layout");

  const elements = document.querySelectorAll(".collection-slide-wrapper");
  let sequence = [];
  let current = 1;
  let addTen = true;

  while (sequence.length < elements.length) {
    sequence.push(current);
    current += addTen ? 10 : 4;
    addTen = !addTen;
  }


  elements.forEach((element, index) => {
    if (sequence.includes(index + 1)) {
      element.style.gridColumn = "span 2";
      element.style.gridRow = "span 2";
      element.querySelector(".product-card").style.height = "100%";
    }
  });
  setTimeout(() => {
    $(".owl-carousel").trigger("refresh.owl.carousel");
  }, 100);
}

// presist layout for collection page
window.addEventListener("DOMContentLoaded", () => {
  loadingState = localStorage.getItem("layout");

  if (wrapper) {
    if (loadingState === "custom_layout") {
      wrapper.classList.add("custom_layout");
      setCustomLayout();
    } else {
      wrapper.classList.remove("custom_layout");
      setDefaultLayout();
    }
  }
  window.addEventListener("resize", () => {
    if (wrapper && window.innerWidth > 768) {
      wrapper.classList.remove("custom_layout");
    }
  });
});

// grid layout switch functionlity ends

// infinite scroll
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.getElementById("collectionWrapper");
  let loading = false;

  const loadMoreProducts = async () => {
    const loadMoreDiv = document.getElementById("load-more");
    const nextUrl = loadMoreDiv?.dataset.nextUrl;

    if (!nextUrl || loading) return;

    loading = true;
    try {
      const response = await fetch(nextUrl);
      const htmlText = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, "text/html");

      const newProducts = doc.querySelectorAll("#collectionWrapper .product-card");
      const nextPageUrl = doc.querySelector("#load-more")?.dataset.nextUrl;

      newProducts.forEach((productCard) => {
        const wrapperDiv = document.createElement("div");
        wrapperDiv.classList.add("collection-slide-wrapper");

        // Get price from .bottom-wrapper <p> (adjust selector if needed)
        const priceText = productCard.querySelector(".bottom-wrapper p")?.textContent || "";
        const cleanPrice = parseFloat(priceText.replace(/[^0-9.]/g, ""));

        // Set data-price attribute
        wrapperDiv.setAttribute("data-price", cleanPrice || "0");

        wrapperDiv.appendChild(productCard);
        wrapper.appendChild(wrapperDiv);
      });

      initOwlCarousels();

      if (nextPageUrl) {
        loadMoreDiv.dataset.nextUrl = nextPageUrl;
      } else {
        loadMoreDiv.remove(); // No more pages
      }
    } catch (error) {
      console.error("Error loading more products:", error);
    } finally {
      loading = false;
    }
  };

  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > lastScrollY;
    lastScrollY = currentScrollY;

    if (!scrollingDown) return;

    const loadMoreDiv = document.getElementById("load-more");
    if (!loadMoreDiv) return;

    const rect = loadMoreDiv.getBoundingClientRect();
    if (rect.top < window.innerHeight + 1000) {
      loadMoreProducts();
    }
  };

  window.addEventListener("scroll", handleScroll);
});


//

function toggleHeart(button) {
}

function adjustParagraph() {
  const paragraphs = document.querySelectorAll(".featured-title");

  paragraphs.forEach((paragraph) => {
    // Clone the paragraph and set it to a temporary container for line measurement
    const tempContainer = document.createElement("div");
    tempContainer.style.position = "absolute";
    tempContainer.style.visibility = "hidden";
    tempContainer.style.whiteSpace = "normal";
    tempContainer.style.wordWrap = "break-word";
    tempContainer.style.lineHeight = "1.5"; // Same line height as the original paragraph
    tempContainer.textContent = paragraph.textContent;
    document.body.appendChild(tempContainer);

    // Measure how many lines the content takes up in the current container
    const tempHeight = tempContainer.clientHeight;
    const lineHeight = parseInt(window.getComputedStyle(paragraph).lineHeight);
    const lines = Math.floor(tempHeight / lineHeight);

    // Remove the temporary container
    document.body.removeChild(tempContainer);

    // If there are more than two lines, modify the paragraph
    const text = paragraph.textContent;
    if (lines > 2) {
      const firstPart = text.split(/\r?\n/)[0]; // First line
      const secondLine = text.split(/\r?\n/)[1]; // Second line

      // Modify the second line to replace the last 3 characters with '...'
      const modifiedSecondLine = secondLine.slice(0, -3) + "...";

      // Update the paragraph content dynamically
      paragraph.innerHTML =
        firstPart +
        '<br><span class="second-line">' +
        modifiedSecondLine +
        "</span>";
    } else {
      // If there's only one or two lines, leave the paragraph unchanged
      paragraph.innerHTML = text;
    }
  });
}

// Call the function initially and on window resize for responsiveness
window.onload = adjustParagraph;
window.onresize = adjustParagraph;

var innerSwipers = document.querySelectorAll(".nested-swiper");
innerSwipers.forEach(function (swiperEl) {
  var innerSwiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 10,
    autoplay: false,
    loop: true,
    pagination: {
      el: swiperEl.querySelector(".swiper-pagination"),
      clickable: true,
    },
    on: {
      slideChange: function () {
        // this.pagination.update();
        // this.pagination.enable();
        // this.update();
      },
    },
    simulateTouch: !("ontouchstart" in window),
  });
  swiperEl.addEventListener("mouseenter", function () {
    if (window.innerWidth > 771) {
      innerSwiper.params.autoplay = {
        delay: 1500,
        disableOnInteraction: false,
      };
      innerSwiper.autoplay.start();
    }
  });
  swiperEl.addEventListener("mouseleave", function () {
    innerSwiper.autoplay.stop();
  });
});

// sort
const sortBtnMob = document.getElementById("sortBtnMob");
const filterBtnMob = document.getElementById("filterBtnMob");
const sortModalMobile = document.getElementById("sortModalMobile");
const sortSectionMob = document.getElementById("sortSectionMob");

let lastAccordion = null;

function closeAllAccordions() {
  document
    .querySelectorAll(".mob-sort-filter-accordion-item")
    .forEach((accordion) => {
      let bsCollapse = new bootstrap.Collapse(accordion, {
        toggle: false,
      });
      bsCollapse.hide();
    });
}

function openSpecificAccordion(accordionId) {
  let accordionEl = document.getElementById(accordionId);
  if (accordionEl) {
    let accordion = new bootstrap.Collapse(accordionEl, {
      toggle: true,
    });
    lastAccordion = accordionId;
  }
}

function collapseAccordion(accordionId) {
  let accordionEl = document.getElementById(accordionId);
  if (accordionEl) {
    let accordion = new bootstrap.Collapse(accordionEl, {
      toggle: true,
    });
  }
}

// Only add event listeners if elements exist
if (sortBtnMob) {
  sortBtnMob.addEventListener("click", function () {
    let accordionId = this.getAttribute("data-accordion");
    closeAllAccordions();
    openSpecificAccordion(accordionId);
  });
}

if (filterBtnMob) {
  filterBtnMob.addEventListener("click", function () {
    let accordionId = this.getAttribute("data-accordion");
    closeAllAccordions();
    openSpecificAccordion(accordionId);
  });
}

if (sortModalMobile) {
  sortModalMobile.addEventListener("hidden.bs.offcanvas", function () {
    closeAllAccordions();
  });
}

function setDynamicHeight() {
  if (sortSectionMob && sortModalMobile) {
    let targetHeight = sortSectionMob.offsetHeight;
    sortModalMobile.style.bottom = `${targetHeight}px`;
  }
}

setDynamicHeight();
window.addEventListener("resize", setDynamicHeight);

// make sticky and normal switch the sort sticky
document.addEventListener("DOMContentLoaded", function () {
  const stickyElement = document.querySelector(".sort_section");
  if (stickyElement) {
    const originalPosition =
      stickyElement.getBoundingClientRect().top + window.scrollY; // Store original position

    function handleScroll() {
      const elementTop = stickyElement.getBoundingClientRect().top;

      // If the element enters the viewport, make it sticky
      if (elementTop <= window.innerHeight) {
        stickyElement.classList.add("sticky-element");
      }

      // If the user scrolls back above the element's original position, remove sticky
      if (window.scrollY < originalPosition) {
        stickyElement.classList.remove("sticky-element");
      }
    }

    window.addEventListener("scroll", handleScroll);
  }
});

// filter form
// Filter accordion toggle logic
document.querySelectorAll(".filter-details").forEach((details) => {
  const plusSvg = details.querySelector(".plus-svg");
  const minusSvg = details.querySelector(".minus-svg");
  const content = details.querySelector(".accordion-content");

  details.addEventListener("toggle", () => {
    if (details.open) {
      content.style.height = content.scrollHeight + "px";
      content.style.opacity = 1;
      minusSvg.classList.remove("d-none");
      plusSvg.classList.add("d-none");
    } else {
      content.style.height = 0;
      content.style.opacity = 0;
      plusSvg.classList.remove("d-none");
      minusSvg.classList.add("d-none");
    }
  });
});

// Clear button (works for all instances)
document.querySelectorAll("#filterFormClearBtn").forEach((clearBtn) => {
  clearBtn.addEventListener("click", (e) => {
    e.preventDefault();
    const url = new URL(window.location.href);
    // Remove all filter parameters
    url.search = ""; // Or selectively: url.searchParams.delete('filter');
    window.location.href = url.toString();
  });
});

// Wait for DOM before initializing sliders
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".filter-form").forEach((form) => {
    const rangeInputs = form.querySelectorAll(
      ".range-input input[type='range']"
    );
    const priceInputs = form.querySelectorAll(
      ".price-input input[type='number']"
    );
    const rangeBar = form.querySelector(".slider .progress");

    if (!rangeInputs.length || !priceInputs.length || !rangeBar) return;

    const priceGap = 1000;

    const updateProgressBar = () => {
      const minVal = parseInt(rangeInputs[0].value) || 0;
      const maxVal = parseInt(rangeInputs[1].value) || 0;
      const maxRange = parseInt(rangeInputs[1].max) || 100;

      rangeBar.style.left = (minVal / maxRange) * 100 + "%";
      rangeBar.style.right = 100 - (maxVal / maxRange) * 100 + "%";
    };

    const syncRangeWithInputs = () => {
      priceInputs[0].value = rangeInputs[0].value;
      priceInputs[1].value = rangeInputs[1].value;
      updateProgressBar();
    };

    const syncInputsWithRange = () => {
      rangeInputs[0].value = priceInputs[0].value;
      rangeInputs[1].value = priceInputs[1].value;
      updateProgressBar();
    };

    const handleRangeInput = (e) => {
      let minVal = parseInt(rangeInputs[0].value) || 0;
      let maxVal = parseInt(rangeInputs[1].value) || 0;

      if (maxVal - minVal < priceGap) {
        if (e.target.classList.contains("range-min")) {
          rangeInputs[0].value = maxVal - priceGap;
        } else {
          rangeInputs[1].value = minVal + priceGap;
        }
      } else {
        syncRangeWithInputs();
      }
    };

    rangeInputs.forEach((input) => {
      input.addEventListener("input", handleRangeInput);
      input.addEventListener("change", handleRangeInput);
      input.addEventListener("touchstart", handleRangeInput);
      input.addEventListener("touchmove", handleRangeInput);
      input.addEventListener("touchend", handleRangeInput);
    });

    priceInputs.forEach((input) => {
      input.addEventListener("input", (e) => {
        let minPrice = parseInt(priceInputs[0].value) || 0;
        let maxPrice = parseInt(priceInputs[1].value) || 0;
        let maxRange = parseInt(rangeInputs[1].max) || 100;

        if (maxPrice - minPrice >= priceGap && maxPrice <= maxRange) {
          if (e.target.classList.contains("input-min")) {
            rangeInputs[0].value = minPrice;
          } else {
            rangeInputs[1].value = maxPrice;
          }
          updateProgressBar();
        } else {
          syncInputsWithRange();
        }
      });
    });

    // Initialize on load
    syncRangeWithInputs();
  });
});
